<section class="full-width">
  <ds-message
    [tone]="inlineMessage.tone"
    [isDismissable]="true"
    [messageText]="inlineMessages"
    [isVisible]="inlineMessage.showInlineMessage"
  ></ds-message>
  <ng-template #inlineMessages>
    @if(inlineMessage.message[0]) {
    <!-- <label for="forcedMVRUpdate"></label>  -->
    @for (message of inlineMessage.message[0].messageTexts; track $index) {

    <ul>
      <li>{{message}}</li>
    </ul>
    }
    <br />
    } @if(inlineMessage.message[1]) {
    <!-- <label for="forcedDLUpdate"></label> -->
    @for (message of inlineMessage.message[1].messageTexts; track $index) {

    <ul>
      <li>{{message}}</li>
    </ul>
    } }
  </ng-template>

  <ds-modal
    #modal
    [ds-modal-trigger-for]="modal"
    [isModalOpen]="modalData.showModal"
    [isDismissable]="false"
    (dismiss)="handleModalClosed()"
  >
    <ds-box-header>{{modalData.title}}</ds-box-header>
    <ds-box-content>
      @if(modalData.body[0]) {
      <p class="text-regular">{{modalData.body[0]}}</p>
      <br />
      } @if(modalData.checkboxes?.length !== 0) { @for(checkbox of
      modalData.checkboxes; track checkbox.id; let index = $index;) {

      <ds-form-field>
        <ds-checkbox-group>
          <input
            ds-input
            type="checkbox"
            id="clause-{{checkbox.id}}"
            [(ngModel)]="checkbox.isChecked"
          />
          <label ds-label for="clause-{{checkbox.id}}" class="text-regular">
            {{checkbox.clause}}
          </label>
        </ds-checkbox-group>
      </ds-form-field>
      <ul>
        @for(innerClause of checkbox.innerClauses; track innerClause; let index
        = $index;) {
        <li>
          <label ds-label class="text-regular">{{innerClause}}</label>
        </li>
        }
      </ul>
      }
      <br />
      } @if(modalData.link.length !== 0) {
      <p
        style="cursor: pointer; text-decoration: underline"
        class="text-regular"
        (click)="downloadConsent(modalData.link, modalData)"
      >
        Please click here to download consent document.
      </p>
      <br />
      <br />
      } @if(modalData.body[1]) {
      <p class="text-regular">{{modalData.body[1]}}</p>
      <br />
      }
    </ds-box-content>

    <ds-box-footer>
      @if(modalData.type ==='deleteAuthorizedDriver') {
      <button
        style="margin-right: 1%"
        ds-button
        [disabled]="!areAllModalCheckboxChecked()"
        (click)="handleDeleteAuthorizedDriver(modalData.formGroup)"
      >
        OKAY
      </button>
      } @else if(modalData.type ==='submitAuthorizedDriverForm') {
      <button
        style="margin-right: 1%"
        ds-button
        [disabled]="!areAllModalCheckboxChecked()"
        (click)="handleSubmitAuthorizedDriverForm(modalData.formGroup)"
      >
        OKAY
      </button>
      } @else if(modalData.type ==='submitEmployeeForm') {
      <button
        style="margin-right: 1%"
        ds-button
        [disabled]="!areAllModalCheckboxChecked()"
        (click)="handleSubmitEmployeeForm(modalData.formGroup)"
      >
        OKAY
      </button>
      }
      <button style="margin-right: 1%" ds-button #dsModalDismissElement>
        CLOSE
      </button>
    </ds-box-footer>
  </ds-modal>

  <!-- <app-employee-section
    (submitEmployeeForm)="handleSubmitEmployeeForm()"
    [employeeForm]="employeeForm"
    [allCountriesData]="allCountriesData"
    [allStatesData]="getStatesForSelectedCountryInForm(employeeForm.get('countryCode')?.value ?? '')"
  ></app-employee-section>
  <app-authorized-driver-section
    (submitAuthorizedDriverForm)="handleSubmitAuthorizedDriverForm()"
    (emailConsentToAuthorizedDriver)="handleEmailConsentToAuthorizedDriver()"
    [authorizedDriverForms]="authorizedDriverForms"
  ></app-authorized-driver-section>
  <app-deactivated-authorized-driver-section
    (reactivateAuthorizedDriver)="handleReactivateAuthorizedDriver()"
    [deactivatedAuthorizedDriverForms]="deactivatedAuthorizedDriverForms"
  ></app-deactivated-authorized-driver-section> -->

  <ds-accordion style="margin-top: 1%" #employee_form>
    <ds-accordion-item
      [isOpen]="!(employeeForm.get('_isExistingData')?.getRawValue())"
    >
      Employee
      <div content>
        <div style="display: flex">
          <form [ds-form]="employeeForm" [formGroup]="employeeForm">
            <ds-box style="flex: 1">
              <ds-box-header
                >Employee Details {{`${employeeForm.get('firstName')?.value}
                ${employeeForm.get('middleName')?.value}
                ${employeeForm.get('lastName')?.value}
                ${employeeForm.get('suffix')?.value}`}}</ds-box-header
              >

              <ds-box-content
                [divider]="'full'"
                withBorder="true"
                [accentBarTone]="getFormAccent(employeeForm)"
              >
                <h2>
                  Driver License Information (as it appears in state issued
                  driver license)
                </h2>
                <br />
                <div class="row" style="align-items: flex-start">
                  <ds-form-field class="col-2">
                    <label ds-label for="firstName"> First Name </label>
                    <input
                      id="firstName"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter first name"
                      formControlName="firstName"
                    />
                    @if(employeeForm.controls['firstName'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['firstName'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="middleName"> Middle Name </label>
                    <input
                      id="middleName"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter middle name"
                      formControlName="middleName"
                    />
                    @if(employeeForm.controls['middleName'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['middleName'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="lastName"> Last Name </label>
                    <input
                      id="lastName"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter last name"
                      formControlName="lastName"
                    />
                    @if(employeeForm.controls['lastName'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['lastName'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="suffix"> Suffix </label>
                    <input
                      id="suffix"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter suffix"
                      formControlName="suffix"
                    />
                    @if
                    (employeeForm.controls['suffix'].hasError('doesNotContainOnlyAlphabets'))
                    {
                    <ds-error
                      >This field should only contain alphabets.
                    </ds-error>
                    } @else if
                    (employeeForm.controls['suffix'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="email"> Email </label>
                    <input
                      ds-input
                      id="email"
                      ds-form-validation
                      placeholder="Enter email"
                      formControlName="email"
                    />
                    @if(employeeForm.controls['email'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['email'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    } @else if
                    (employeeForm.controls['email'].hasError('doesNotContainOnlyEmail'))
                    {
                    <ds-error> This field is invalid. </ds-error>
                    }
                  </ds-form-field>
                  <ds-form-field class="col-2">
                    <label ds-label for="dob"> Date of Birth </label>

                    <ds-datepicker
                      id="dob"
                      [config]="getDateConfigForBirthDate()"
                      [viewDate]="employeeForm.get('dateOfBirth')?.value ?? today"
                    >
                      <input
                        ds-date
                        ds-form-validation
                        formControlName="dateOfBirth"
                        placeholder="Enter date of birth"
                      />
                    </ds-datepicker>
                    @if
                    (employeeForm.controls['dateOfBirth'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }@else if
                    (employeeForm.controls['dateOfBirth'].hasError('doesNotContainDatesBeforeToday'))
                    {
                    <ds-error>
                      This field should only contain dates before
                      today.</ds-error
                    >
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="driverLicNumber">
                      Driver License Number
                    </label>
                    <input
                      id="driverLicNumber"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter driver license number"
                      formControlName="driverLicenseNumber"
                    />
                    @if
                    (employeeForm.controls['driverLicenseNumber'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                    {
                    <ds-error>
                      This field should only contain alphabets and numbers.
                    </ds-error>
                    } @else if
                    (employeeForm.controls['driverLicenseNumber'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="driverLic">
                      Driver License Class
                    </label>
                    <input
                      ds-input
                      id="driverLic"
                      ds-form-validation
                      class="capitalize"
                      type="text"
                      placeholder="Enter driver license class"
                      formControlName="driverLicenseClass"
                    />
                    @if
                    (employeeForm.controls['driverLicenseClass'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                    {
                    <ds-error>
                      This field should only contain alphabets and numbers.
                    </ds-error>
                    } @else if
                    (employeeForm.controls['driverLicenseClass'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="expiry"> Expiry Date </label>
                    <ds-datepicker
                      id="expiry"
                      [config]="getDateConfigForExpiryDate()"
                      [viewDate]="employeeForm.get('expiryDate')?.value ?? today"
                    >
                      <input
                        ds-date
                        ds-form-validation
                        formControlName="expiryDate"
                        placeholder="Enter expiry date"
                      />
                    </ds-datepicker>
                    @if
                    (employeeForm.controls['expiryDate'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    } @else if
                    (employeeForm.controls['expiryDate'].hasError('doesNotContainDatesAfterToday'))
                    {
                    <ds-error>
                      This field should only contain dates after
                      today.</ds-error
                    >
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="country"> Country </label>
                    <ds-select
                      id="country"
                      ds-form-validation
                      formControlName="countryCode"
                      [labellingConfig]="{ placeholder: 'Enter country' }"
                      [options]="allCountriesOption"
                    ></ds-select>
                    @if
                    (employeeForm.controls['countryCode'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="issurance">
                      Issuance State / Province
                    </label>
                    <ds-select
                      id="issurance"
                      ds-form-validation
                      formControlName="stateProvinceCode"
                      [labellingConfig]="{ placeholder: 'Enter state' }"
                      [options]="allStatesOption"
                    ></ds-select>
                    @if
                    (employeeForm.controls['stateProvinceCode'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="zipcode">
                      Zipcode / Postal Code
                    </label>
                    <input
                      id="zipcode"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter zip code"
                      formControlName="zipCode"
                    />
                    @if
                    (employeeForm.controls['zipCode'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                    {
                    <ds-error>
                      This field should only contain alphabets and numbers.
                    </ds-error>
                    } @else if
                    (employeeForm.controls['zipCode'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="address1"> Address Line 1 </label>
                    <input
                      id="address1"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter address line 1"
                      formControlName="addressLine1"
                    />
                    @if(employeeForm.controls['addressLine1'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['addressLine1'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="address2"> Address Line 2 </label>
                    <input
                      id="address2"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter address line 2"
                      formControlName="addressLine2"
                    />
                    @if(employeeForm.controls['addressLine2'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['addressLine2'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="city"> City </label>
                    <input
                      id="city"
                      ds-input
                      ds-form-validation
                      type="text"
                      placeholder="Enter city"
                      formControlName="city"
                    />
                    @if(employeeForm.controls['city'].hasError('startsWithSpace'))
                    {
                    <ds-error> This field cannot start with space. </ds-error>
                    } @else if
                    (employeeForm.controls['city'].hasError('required')) {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <label ds-label for="lastFour">
                      Last Four Digits of SSN
                    </label>
                    <input
                      id="lastFour"
                      ds-input
                      ds-form-validation
                      type="password"
                      placeholder="Enter last four digits of SSN"
                      [withPasswordToggle]="true"
                      formControlName="last4DigitsSSN"
                    />
                    @if
                    (employeeForm.controls['last4DigitsSSN'].hasError('doesNotContainOnlyFourNumbers'))
                    {
                    <ds-error>
                      This field cannot contain space and should only contain
                      four digit number (excluding 0000).
                    </ds-error>
                    } @else if
                    (employeeForm.controls['last4DigitsSSN'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field>

                  <ds-form-field class="col-2">
                    <ds-checkbox-group>
                      <input
                        id="motorEndorse"
                        ds-input
                        type="checkbox"
                        ds-form-validation
                        formControlName="mcEndorsementInd"
                      />
                      <label ds-label for="motorEndorse"
                        >Motorcycle Endorsement</label
                      >
                    </ds-checkbox-group>
                  </ds-form-field>

                  <!-- <ds-form-field class="col-2">
                    <ds-checkbox-group>
                      <input
                        ds-input
                        type="checkbox"
                        ds-form-validation
                        formControlName="under18Indicator"
                      />
                      <label
                        ds-label
                        >Under 18 Years</label
                      >
                    </ds-checkbox-group>
                    @if
                    (employeeForm.controls['under18Indicator'].hasError('required'))
                    {
                    <ds-error> This field is required. </ds-error>
                    }
                  </ds-form-field> -->

                  <ds-form-field class="col-2">
                    <label ds-label for="lastCons">
                      Last Consented Timestamp
                    </label>
                    <!-- <ds-datepicker [(config)]="datepickerConfig">
                    <input
                      ds-date
                      ds-form-validation
                      formControlName="lastConsentedTimeStamp"
                    />
                  </ds-datepicker> -->
                    <input
                      id="lastCons"
                      ds-input
                      ds-form-validation
                      placeholder=""
                      formControlName="lastConsentedTimeStamp"
                    />
                  </ds-form-field>
                </div>
              </ds-box-content>
              <ds-box-footer class="d-flex justify-content-end">
                <div class="inner-form-buttons">
                  <button
                    ds-button
                    aria-label="Submit Employee Form"
                    (click)="handleSubmitEmployeeFormModal(employeeForm)"
                  >
                    SUBMIT
                  </button>
                </div>
              </ds-box-footer>
            </ds-box>
          </form>
        </div>
        @if(currentEnvironment === 'development') {
        <div>
          {{employeeForm.getRawValue()|json}} status - {{employeeForm.status}}
          pristine - {{employeeForm.pristine}} dirty - {{employeeForm.dirty}}
        </div>
        }
      </div>
    </ds-accordion-item>
  </ds-accordion>

  <ds-accordion style="margin-top: 1%" #authorized_driver_forms>
    <ds-accordion-item>
      Authorized Drivers
      <div content>
        <div>
          @for(authorizedDriverForm of authorizedDriverForms; track
          authorizedDriverForm.controls._id.value; let index = $index ) {
          <ds-accordion [allowMultipleOpened]="true">
            <ds-accordion-item
              [isOpen]="!(authorizedDriverForm.get('_isExistingData')?.getRawValue())"
            >
              <span
                >Authorized Driver Details
                {{`${authorizedDriverForm.get('firstName')?.value}
                ${authorizedDriverForm.get('middleName')?.value}
                ${authorizedDriverForm.get('lastName')?.value}
                ${authorizedDriverForm.get('suffix')?.value}`}}</span
              >

              <div content>
                <ds-box-content>
                  <form
                    [ds-form]="authorizedDriverForm"
                    [formGroup]="authorizedDriverForm"
                  >
                    <ds-box style="flex: 1">
                      <ds-box-content
                        [divider]="'full'"
                        withBorder="true"
                        style="height: 500px"
                        [accentBarTone]="getFormAccent(authorizedDriverForm)"
                      >
                        <h2>
                          Driver License Information (as it appears in state
                          issued driver license)
                        </h2>
                        <br />
                        <div class="row" style="align-items: flex-start">
                          <ds-form-field class="col-2">
                            <label ds-label for="firstNam"> First Name </label>
                            <input
                              id="firstNam"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter first name"
                              formControlName="firstName"
                            />
                            @if(authorizedDriverForm.controls['firstName'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['firstName'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="middleNam">
                              Middle Name
                            </label>
                            <input
                              id="middleNam"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter middle name"
                              formControlName="middleName"
                            />
                            @if(authorizedDriverForm.controls['middleName'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['middleName'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="lastName1"> Last Name </label>
                            <input
                              id="lastName1"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter last name"
                              formControlName="lastName"
                            />
                            @if(authorizedDriverForm.controls['lastName'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['lastName'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="sufix"> Suffix </label>
                            <input
                              id="sufix"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter suffix"
                              formControlName="suffix"
                            />
                            @if
                            (authorizedDriverForm.controls['suffix'].hasError('doesNotContainOnlyAlphabets'))
                            {
                            <ds-error
                              >This field should only contain alphabets.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['suffix'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="email"> Email </label>
                            <input
                              id="email"
                              ds-input
                              ds-form-validation
                              placeholder="Enter email"
                              formControlName="email"
                            />
                            @if(authorizedDriverForm.controls['email'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['email'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['email'].hasError('doesNotContainOnlyEmail'))
                            {
                            <ds-error> This field is invalid. </ds-error>
                            }
                          </ds-form-field>
                          <ds-form-field class="col-2">
                            <label ds-label for="DOB1"> Date of Birth </label>

                            <ds-datepicker
                              id="DOB1"
                              [config]="getDateConfigForBirthDate()"
                              [viewDate]="authorizedDriverForm.get('dateOfBirth')?.value ?? today"
                            >
                              <input
                                ds-date
                                ds-form-validation
                                formControlName="dateOfBirth"
                                placeholder="Enter date of birth"
                              />
                            </ds-datepicker>
                            @if
                            (authorizedDriverForm.controls['dateOfBirth'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }@else if
                            (employeeForm.controls['dateOfBirth'].hasError('doesNotContainDatesBeforeToday'))
                            {
                            <ds-error>
                              This field should only contain dates before
                              today.</ds-error
                            >
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="driverLic1">
                              Driver License Number
                            </label>
                            <input
                              id="driverLic1"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter driver license number"
                              formControlName="driverLicenseNumber"
                            />
                            @if
                            (authorizedDriverForm.controls['driverLicenseNumber'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                            {
                            <ds-error>
                              This field should only contain alphabets and
                              numbers.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['driverLicenseNumber'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="driverLicClass1">
                              Driver License Class
                            </label>
                            <input
                              id="driverLicClass1"
                              ds-input
                              ds-form-validation
                              type="text"
                              class="capitalize"
                              placeholder="Enter driver license class"
                              formControlName="driverLicenseClass"
                            />
                            @if
                            (authorizedDriverForm.controls['driverLicenseClass'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                            {
                            <ds-error>
                              This field should only contain alphabets and
                              numbers.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['driverLicenseClass'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="expiryDate1">
                              Expiry Date
                            </label>
                            <ds-datepicker
                              id="expiryDate1"
                              [config]="getDateConfigForExpiryDate()"
                              [viewDate]="authorizedDriverForm.get('expiryDate')?.value ?? today"
                            >
                              <input
                                ds-date
                                ds-form-validation
                                formControlName="expiryDate"
                                placeholder="Enter expiry date"
                              />
                            </ds-datepicker>
                            @if
                            (authorizedDriverForm.controls['expiryDate'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }@else if
                            (employeeForm.controls['expiryDate'].hasError('doesNotContainDatesAfterToday'))
                            {
                            <ds-error>
                              This field should only contain dates after
                              today.</ds-error
                            >
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="country1"> Country </label>
                            <ds-select
                              id="country1"
                              ds-form-validation
                              formControlName="countryCode"
                              [labellingConfig]="{ placeholder: 'Enter country' }"
                              [options]="allCountriesOption"
                            ></ds-select>
                            @if
                            (authorizedDriverForm.controls['countryCode'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="issuanceState">
                              Issuance State / Province
                            </label>
                            <ds-select
                              id="issuanceState"
                              ds-form-validation
                              formControlName="stateProvinceCode"
                              [labellingConfig]="{ placeholder: 'Enter state' }"
                              [options]="allStatesOption"
                            ></ds-select>
                            @if
                            (authorizedDriverForm.controls['stateProvinceCode'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="zipCode">
                              Zipcode / Postal Code
                            </label>
                            <input
                              id="zipCode"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter zip code"
                              formControlName="zipCode"
                            />
                            @if
                            (authorizedDriverForm.controls['zipCode'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                            {
                            <ds-error>
                              This field should only contain alphabets and
                              numbers.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['zipCode'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="address12">
                              Address Line 1
                            </label>
                            <input
                              id="address12"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter address line 1"
                              formControlName="addressLine1"
                            />
                            @if(authorizedDriverForm.controls['addressLine1'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['addressLine1'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="address22">
                              Address Line 2
                            </label>
                            <input
                              id="address22"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter address line 2"
                              formControlName="addressLine2"
                            />
                            @if(authorizedDriverForm.controls['addressLine2'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['addressLine2'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="city1"> City </label>
                            <input
                              id="city1"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter city"
                              formControlName="city"
                            />
                            @if(authorizedDriverForm.controls['city'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['city'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="lastFourssn">
                              Last Four Digits of SSN
                            </label>
                            <input
                              id="lastFourssn"
                              ds-input
                              ds-form-validation
                              type="password"
                              placeholder="Enter last four digits of SSN"
                              [withPasswordToggle]="true"
                              formControlName="last4DigitsSSN"
                            />
                            @if
                            (authorizedDriverForm.controls['last4DigitsSSN'].hasError('doesNotContainOnlyFourNumbers'))
                            {
                            <ds-error>
                              This field cannot contain space and should only
                              contain four digit number (excluding 0000).
                            </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['last4DigitsSSN'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <ds-checkbox-group>
                              <input
                                id="motor2"
                                ds-input
                                type="checkbox"
                                ds-form-validation
                                formControlName="mcEndorsementInd"
                              />
                              <label ds-label for="motor2"
                                >Motorcycle Endorsement</label
                              >
                            </ds-checkbox-group>
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <ds-checkbox-group>
                              <input
                                id="under18"
                                ds-input
                                type="checkbox"
                                ds-form-validation
                                formControlName="under18Indicator"
                              />
                              <label ds-label for="under18"
                                >Under 18 Years</label
                              >
                            </ds-checkbox-group>
                            @if
                            (authorizedDriverForm.controls['under18Indicator'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="lastCons">
                              Last Consented Timestamp
                            </label>
                            <!-- <ds-datepicker [(config)]="datepickerConfig">
                    <input
                      ds-date
                      ds-form-validation
                      formControlName="lastConsentedTimeStamp"
                    />
                  </ds-datepicker> -->
                            <input
                              id="lastCons"
                              ds-input
                              ds-form-validation
                              placeholder=""
                              formControlName="lastConsentedTimeStamp"
                            />
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <ds-checkbox-group>
                              <input
                                id="primary"
                                ds-input
                                type="checkbox"
                                ds-form-validation
                                formControlName="primaryDriverInd"
                              />
                              <label ds-label for="primary"
                                >Primary Driver</label
                              >
                            </ds-checkbox-group>
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="relationship1">
                              Relationship to Employee
                            </label>
                            <ds-select
                              id="relationship1"
                              ds-form-validation
                              formControlName="relationToEmployee"
                              [labellingConfig]="{ placeholder: 'Enter relation' }"
                              [options]="allRelationshipOption"
                            ></ds-select>
                            @if
                            (authorizedDriverForm.controls['relationToEmployee'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>
                          <ds-form-field class="col-2 mb-2x">
                            <label ds-label for="uploadConsent">
                              Upload Consent
                            </label>
                            <input
                              id="uploadConsent"
                              #fileInput
                              ds-input
                              ds-form-validation
                              type="file"
                              formControlName="consentFile"
                              accept="application/pdf"
                              (change)="onFileUpload(authorizedDriverForm, $event)"
                              [labellingConfig]="{ empty: 'Upload signed consent PDF' }"
                            />
                            <input
                              ds-input
                              ds-form-validation
                              placeholder=""
                              type="text"
                              formControlName="base64ConsentFile"
                            />
                            @if
                            (authorizedDriverForm.controls['consentFile'].hasError('badSize'))
                            {
                            <ds-error> This field is required. </ds-error>
                            } @else if
                            (authorizedDriverForm.controls['consentFile'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>
                        </div>
                      </ds-box-content>
                      <ds-box-footer class="d-flex justify-content-between">
                        <div>
                          @if(showEmailConsentButtonInAuthorizedDriverSection(authorizedDriverForm))
                          {
                          <button
                            ds-button
                            aria-label="Email Consent to Authorized Driver"
                            (click)="handleSaveAuthorizedDriverInTempTable(authorizedDriverForm)"
                          >
                            EMAIL CONSENT
                          </button>
                          }
                        </div>
                        <div class="auth-rt-btn">
                          @if(showSubmitButtonInAuthorizedDriverSection(authorizedDriverForm))
                          {
                          <button
                            ds-button
                            aria-label="Submit Authorized Driver Form"
                            (click)="handleSubmitAuthorizedDriverFormModal(authorizedDriverForm)"
                          >
                            SUBMIT
                          </button>
                          } @if(showDeleteButtonInAuthorizedDriverSection()) {
                          <button
                            ds-button
                            aria-label="Delete Authorized Driver"
                            (click)="handleDeleteAuthorizedDriverModal(authorizedDriverForm)"
                          >
                            DELETE AUTHORIZED DRIVER
                          </button>
                          }
                        </div></ds-box-footer
                      >
                    </ds-box>
                  </form>
                  <br />
                  @if(currentEnvironment === 'development') {
                  <div>
                    {{authorizedDriverForm.getRawValue()|json}} status -
                    {{authorizedDriverForm.status}} pristine -
                    {{authorizedDriverForm.pristine}} dirty -
                    {{authorizedDriverForm.dirty}}
                  </div>
                  }
                </ds-box-content>
              </div>
            </ds-accordion-item>
          </ds-accordion>
          }
        </div>
        @if(showAddNewFormButtonInAuthorizedDriverSection()) {
        <button
          style="margin-top: 1%"
          ds-button
          aria-label="Add Authorized Driver"
          (click)="handleAddAuthorizedDriver()"
        >
          ADD AUTHORIZED DRIVER
        </button>
        }
      </div>
    </ds-accordion-item>
  </ds-accordion>

  <ds-accordion style="margin-top: 1%" #deactivated_authorized_driver_forms>
    <ds-accordion-item>
      Deactivated Authorized Drivers
      <div content>
        <div>
          @for(deactivatedAuthorizedDriverForm of
          deactivatedAuthorizedDriverForms; track
          deactivatedAuthorizedDriverForm.controls._id.value; let index = $index
          ) {
          <ds-accordion>
            <ds-accordion-item
              [isOpen]="!(deactivatedAuthorizedDriverForm.get('_isExistingData')?.getRawValue())"
            >
              <span
                >Deactivated Authorized Driver Details
                {{`${deactivatedAuthorizedDriverForm.get('firstName')?.value}
                ${deactivatedAuthorizedDriverForm.get('middleName')?.value}
                ${deactivatedAuthorizedDriverForm.get('lastName')?.value}
                ${deactivatedAuthorizedDriverForm.get('suffix')?.value}`}}</span
              >

              <div content>
                <ds-box-content>
                  <form
                    [ds-form]="deactivatedAuthorizedDriverForm"
                    [formGroup]="deactivatedAuthorizedDriverForm"
                  >
                    <ds-box style="flex: 1">
                      <ds-box-content
                        [divider]="'full'"
                        withBorder="true"
                        style="height: 500px"
                        [accentBarTone]="getFormAccent(deactivatedAuthorizedDriverForm)"
                      >
                        <h2>
                          Driver License Information (as it appears in state
                          issued driver license)
                        </h2>
                        <br />
                        <div class="row" style="align-items: flex-start">
                          <ds-form-field class="col-2">
                            <label ds-label for="firstName3">
                              First Name
                            </label>
                            <input
                              id="firstName3"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter first name"
                              formControlName="firstName"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['firstName'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['firstName'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="middleName3">
                              Middle Name
                            </label>
                            <input
                              id="middleName3"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter middle name"
                              formControlName="middleName"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['middleName'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['middleName'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="lastName3"> Last Name </label>
                            <input
                              id="lastName3"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter last name"
                              formControlName="lastName"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['lastName'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['lastName'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="suffix1"> Suffix </label>
                            <input
                              id="suffix1"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter suffix"
                              formControlName="suffix"
                            />
                            @if
                            (deactivatedAuthorizedDriverForm.controls['suffix'].hasError('doesNotContainOnlyAlphabets'))
                            {
                            <ds-error
                              >This field should only contain alphabets.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['suffix'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="email3"> Email </label>
                            <input
                              id="email3"
                              ds-input
                              ds-form-validation
                              placeholder="Enter email"
                              formControlName="email"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['email'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['email'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['email'].hasError('doesNotContainOnlyEmail'))
                            {
                            <ds-error> This field is invalid. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="dob3"> Date of Birth </label>

                            <ds-datepicker
                              id="dob3"
                              [config]="getDateConfigForBirthDate()"
                              [viewDate]="deactivatedAuthorizedDriverForm.get('dateOfBirth')?.value ?? today"
                            >
                              <input
                                ds-date
                                ds-form-validation
                                formControlName="dateOfBirth"
                                placeholder="Enter date of birth"
                              />
                            </ds-datepicker>
                            @if
                            (deactivatedAuthorizedDriverForm.controls['dateOfBirth'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }@else if
                            (employeeForm.controls['dateOfBirth'].hasError('doesNotContainDatesBeforeToday'))
                            {
                            <ds-error>
                              This field should only contain dates before
                              today.</ds-error
                            >
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="driverLicNumber">
                              Driver License Number
                            </label>
                            <input
                              id="driverLicNumber"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter driver license number"
                              formControlName="driverLicenseNumber"
                            />
                            @if
                            (deactivatedAuthorizedDriverForm.controls['driverLicenseNumber'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                            {
                            <ds-error>
                              This field should only contain alphabets and
                              numbers.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['driverLicenseNumber'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="driverLicense3">
                              Driver License Class
                            </label>
                            <input
                              id="driverLicense3"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter driver license class"
                              class="capitalize"
                              formControlName="driverLicenseClass"
                            />
                            @if
                            (deactivatedAuthorizedDriverForm.controls['driverLicenseClass'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                            {
                            <ds-error>
                              This field should only contain alphabets and
                              numbers.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['driverLicenseClass'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="expiryDate3">
                              Expiry Date
                            </label>
                            <ds-datepicker
                              id="expiryDate3"
                              [config]="getDateConfigForExpiryDate()"
                              [viewDate]="deactivatedAuthorizedDriverForm.get('expiryDate')?.value ?? today"
                            >
                              <input
                                ds-date
                                ds-form-validation
                                formControlName="expiryDate"
                                placeholder="Enter expiry date"
                              />
                            </ds-datepicker>
                            @if
                            (deactivatedAuthorizedDriverForm.controls['expiryDate'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }@else if
                            (employeeForm.controls['expiryDate'].hasError('doesNotContainDatesAfterToday'))
                            {
                            <ds-error>
                              This field should only contain dates after
                              today.</ds-error
                            >
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="country2"> Country </label>
                            <ds-select
                              id="country2"
                              ds-form-validation
                              formControlName="countryCode"
                              [labellingConfig]="{ placeholder: 'Enter country' }"
                              [options]="allCountriesOption"
                            ></ds-select>
                            @if
                            (deactivatedAuthorizedDriverForm.controls['countryCode'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="issuance">
                              Issuance State / Province
                            </label>
                            <ds-select
                              id="issuance"
                              ds-form-validation
                              formControlName="stateProvinceCode"
                              [labellingConfig]="{ placeholder: 'Enter state' }"
                              [options]="allStatesOption"
                            ></ds-select>
                            @if
                            (deactivatedAuthorizedDriverForm.controls['stateProvinceCode'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="zipcode">
                              Zipcode / Postal Code
                            </label>
                            <input
                              id="zipcode"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter zip code"
                              formControlName="zipCode"
                            />
                            @if
                            (deactivatedAuthorizedDriverForm.controls['zipCode'].hasError('doesNotContainOnlyAlphabetsAndNumbers'))
                            {
                            <ds-error>
                              This field should only contain alphabets and
                              numbers.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['zipCode'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="address31">
                              Address Line 1
                            </label>
                            <input
                              id="address31"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter address line 1"
                              formControlName="addressLine1"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['addressLine1'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['addressLine1'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="address23">
                              Address Line 2
                            </label>
                            <input
                              id="address23"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter address line 2"
                              formControlName="addressLine2"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['addressLine2'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['addressLine2'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="city3"> City </label>
                            <input
                              id="city3"
                              ds-input
                              ds-form-validation
                              type="text"
                              placeholder="Enter city"
                              formControlName="city"
                            />
                            @if(deactivatedAuthorizedDriverForm.controls['city'].hasError('startsWithSpace'))
                            {
                            <ds-error>
                              This field cannot start with space.
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['city'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="lastFour3">
                              Last Four Digits of SSN
                            </label>
                            <input
                              id="lastFour3"
                              ds-input
                              ds-form-validation
                              type="password"
                              placeholder="Enter last four digits of SSN"
                              [withPasswordToggle]="true"
                              formControlName="last4DigitsSSN"
                            />
                            @if
                            (deactivatedAuthorizedDriverForm.controls['last4DigitsSSN'].hasError('doesNotContainOnlyFourNumbers'))
                            {
                            <ds-error>
                              This field cannot contain space and should only
                              contain four digit number (excluding 0000).
                            </ds-error>
                            } @else if
                            (deactivatedAuthorizedDriverForm.controls['last4DigitsSSN'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <ds-checkbox-group>
                              <input
                                id="motor3"
                                ds-input
                                type="checkbox"
                                ds-form-validation
                                formControlName="mcEndorsementInd"
                              />
                              <label ds-label for="motor3"
                                >Motorcycle Endorsement</label
                              >
                            </ds-checkbox-group>
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <ds-checkbox-group>
                              <input
                                id="under182"
                                ds-input
                                type="checkbox"
                                ds-form-validation
                                formControlName="under18Indicator"
                              />
                              <label ds-label for="under182"
                                >Under 18 Years</label
                              >
                            </ds-checkbox-group>
                            @if
                            (deactivatedAuthorizedDriverForm.controls['under18Indicator'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="lastCon3">
                              Last Consented Timestamp
                            </label>
                            <!-- <ds-datepicker [(config)]="datepickerConfig">
                    <input
                      ds-date
                      ds-form-validation
                      formControlName="lastConsentedTimeStamp"
                    />
                  </ds-datepicker> -->
                            <input
                              id="lastCon3"
                              ds-input
                              ds-form-validation
                              placeholder=""
                              formControlName="lastConsentedTimeStamp"
                            />
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <ds-checkbox-group>
                              <input
                                id="primary3"
                                ds-input
                                type="checkbox"
                                ds-form-validation
                                formControlName="primaryDriverInd"
                              />
                              <label ds-label for="primary3"
                                >Primary Driver</label
                              >
                            </ds-checkbox-group>
                          </ds-form-field>

                          <ds-form-field class="col-2">
                            <label ds-label for="relationship3">
                              Relationship to Employee
                            </label>
                            <ds-select
                              id="relationship3"
                              ds-form-validation
                              formControlName="relationToEmployee"
                              [labellingConfig]="{ placeholder: 'Enter relation' }"
                              [options]="allRelationshipOption"
                            ></ds-select>
                            @if
                            (deactivatedAuthorizedDriverForm.controls['relationToEmployee'].hasError('required'))
                            {
                            <ds-error> This field is required. </ds-error>
                            }
                          </ds-form-field>
                        </div>
                      </ds-box-content>
                      <ds-box-footer class="d-flex justify-content-between">
                        <div></div>
                        <div class="auth-rt-btn">
                          <button
                            ds-button
                            aria-label="Reactivate Authorized Driver"
                            (click)="handleReactivateAuthorizedDriver(deactivatedAuthorizedDriverForm)"
                          >
                            REACTIVATE AUTHORIZED DRIVER
                          </button>
                        </div></ds-box-footer
                      >
                    </ds-box>
                  </form>
                  <br />
                  @if(currentEnvironment === 'development') {
                  <div>
                    {{deactivatedAuthorizedDriverForm.getRawValue()|json}}
                    {{deactivatedAuthorizedDriverForm.status}}
                    {{deactivatedAuthorizedDriverForm.pristine}}
                    {{deactivatedAuthorizedDriverForm.dirty}}
                  </div>
                  }
                </ds-box-content>
              </div>
            </ds-accordion-item>
          </ds-accordion>
          }
        </div>
      </div>
    </ds-accordion-item>
  </ds-accordion>

  <div class="buttons">
    <button ds-button aria-label="Submit" (click)="handleRefresh()">
      RESET
    </button>
    <div class="links">
      <a
        label="How to Enroll Guide"
        class="fake-anchor"
        (click)="openLinkInNewTab('enrollGuideDocument')"
        >How to Enroll Guide</a
      >
      <a
        class="fake-anchor"
        label="Summary of Rights"
        (click)="openLinkInNewTab('summaryOfRightsDocument')"
        >Summary of Rights</a
      >
      <a
        class="fake-anchor"
        label="Company Car Policy"
        (click)="openLinkInNewTab('carPolicyDocument')"
        >Company Car Policy</a
      >
    </div>
  </div>
</section>
